import { NgClass } from '@angular/common';
import { Component, computed, input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconComponent } from 'projects/components/pay-icon/icon.component';
import { IconNames } from 'projects/components/pay-icon/IconNames';
import { ServerIncidentsIncident } from 'projects/login/src/app/services/server-status/models/server-incidents-incident';

@Component({
  selector: 'pay-login-server-status',
  imports: [IconComponent, NgClass],
  templateUrl: './server-status.component.html',
  styleUrl: './server-status.component.scss',
})
export class ServerStatusComponent {
  private translateService = inject(TranslateService);

  readonly incidents = input<ServerIncidentsIncident[]>();
  readonly value = computed(() => {
    if (!this.incidents) {
      return this.translateService.instant('status.retrieval-error');
    }

    if (this.incidents()?.length === 0) {
      return this.translateService.instant('status.all-good');
    }
    const filtersIncidents =
      this.incidents()
        ?.flatMap((x) => x.components?.map((y) => y.name))
        .filter((value, index, self) => self.indexOf(value) === index) ?? [];

    if (filtersIncidents.length <= 4) {
      return this.translateService.instant('status.problems_with') + filtersIncidents.slice(0, 4).join(', ');
    }
    return (
      this.translateService.instant('status.problems_with') +
      filtersIncidents.slice(0, 4).join(', ') +
      this.translateService.instant('status.and_x', { others: filtersIncidents.length - 4 })
    );
  });

  readonly colorSchemes = computed(() => {
    if (!this.incidents()) {
      return '';
    }

    if (this.incidents()?.length === 0) {
      return 'bg-success-20 text-success-150 border-success-150';
    }

    if (this.incidents()?.find((x) => x.impact === 'critical')) {
      return 'bg-negative-25 text-negative-150 border-negative-150';
    }

    return 'bg-warning-30 text-warning-150 border-warning-150';
  });
  protected readonly IconNames = IconNames;

  openLink() {
    const incidents = this.incidents();
    if (!incidents || incidents.length === 0) {
      return 'https://status.pay.nl';
    }

    return incidents[incidents.length - 1].shortlink;
  }
}
